module.exports = __webpack_public_path__ + "img/grey_007.0bbb4e6c.png";